











































































import { Component, Prop, Vue, Inject, Watch } from "vue-property-decorator";

import { validationMixin } from "vuelidate";
import { required, helpers } from "vuelidate/lib/validators";

import { ILocale } from "@/@types/locale";
import { IBar } from "@/@types/menu/bars/bars";

import UploadingImageToServer from "@/components/app/images/uploading-image-to-server.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import CloseButton from "@/components/buttons/close-button.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";

const enalpha = helpers.regex("alpha", /^[a-zA-Z]*$/);

@Component({
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
  components: {
    BSwitch,
    CloseButton,
    UploadingImageToServer,
    submit: SubmitResetButtonGroop,
    LanguagesButtons,
  },
})
export default class AddBarForm extends Vue {
  @Prop({ type: Object, default: null }) bar!: IBar;
  @Inject({ from: "barFolder", default: null }) readonly folder!: string;

  languages = this.$store.getters.getLanguages;
  locale = this.languages[0];
  show = true;

  name = "";
  names: ILocale = {};
  poster = "";
  image = "";
  showBar = true;
  delivery = true;

  get getBar(): IBar {
    return {
      _id: this.bar ? this.bar._id : "",
      name: this.names,
      show: this.showBar,
      delivery: this.delivery,
      src: {
        image: this.image,
        poster: this.poster,
      },
    };
  }

  @Watch("name")
  changeName(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("locale")
  updateName(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }
    const id = this.bar ? this.bar._id : "";
    this.$emit("sendBar", id, this.getBar);
  }

  onReset(): void {
    this.name = "";
    this.names = {};
    this.locale = this.languages[0];
    this.poster = "";
    this.image = "";
    this.showBar = false;
    this.delivery = false;

    this.show = false;
    this.$nextTick(() => {
      this.show = true;
    });
  }

  autoFillingForm(): void {
    this.names = this.bar.name;
    this.showBar = this.bar.show;
    this.delivery = this.bar.delivery;
    this.poster = this.bar.src.poster;
    this.image = this.bar.src.image;
    this.updateName();
  }

  mounted(): void {
    if (this.bar && this.bar._id) this.autoFillingForm();
  }
}
